import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    list: [],
    editMemberId: null,
    editMemberCallback: null,
    resetSelected: false,
});

const members = {
    set,
    update,
    subscribe,
    removeGroup: id => {
        members.update( obj => {
            obj.list.map( member => {
                member.in_groups = member.in_groups.filter( g => g != id);
            });
            return obj;
        })
    },
    clearAll: () => {
        members.update(obj => {
            obj.editMemberId = null;
            obj.editMemberCallback = null;
            obj.list.map(member => {
               member.selected = false;
            });
            return obj;
        });
    },
    selectMembers: selected => {
        if (selected.length) {
            members.update(obj => {
                selected.map(id => {
                    let member = obj.list.find(x => x.id == parseInt(id));
                    if (member) {
                        member.selected = true;
                    }
                });
                return obj;
            })
        }
    },
    unselectMembers: () => {
        members.update(obj => {
            obj.list.map(member => {
                member.selected = false;
            });
            obj.resetSelected = true;
            return obj;
        })
    },
    editMember: (id, callBack = null) => {
        update(obj => {
            obj.editMemberId = id;
            obj.editMemberCallback = callBack;
            return obj;
        })
    },
    closeMember: () => {
        update(obj => {
            obj.editMemberId = null;
            obj.editMemberCallback = null;
            return obj;
        })
    },
    deleteMember: id => {
        members.update(obj => {
            const list = obj.list.filter(m => m.id != id);
            obj.list = list;
            return obj;
        })
    },
    updateMember: member => {
        update(obj => {
            let index = obj.list.findIndex(m => m.id == member.id);
            if (index > -1) {
                obj.list[index] = member;
            } else {
                obj.list = [member, ...obj.list];
            }

            if (obj.editMemberCallback) {
                obj.editMemberCallback();
            }
            obj.editMemberCallback = null;
            return obj;
        })
    },
}

export default members;